enum WorkOrderFileShareAction {
  None = "None",
  Share = "Share",
  Unshare = "Unshare",
}

export default WorkOrderFileShareAction;
